import React, { useMemo } from 'react';
import NewsActivity from 'app/components/district/news/NewsActivity';
import { ActivityList } from 'app/components/district/common/ActivityStyles';
export default function NewsList(_ref) {
  let {
    data
  } = _ref;
  const newsList = useMemo(() => data.pages.map(page => page.data).flat(), [data.pages]);
  return /*#__PURE__*/React.createElement(ActivityList, {
    "data-sentry-element": "ActivityList",
    "data-sentry-component": "NewsList",
    "data-sentry-source-file": "NewsList.tsx"
  }, newsList.map(news => {
    return /*#__PURE__*/React.createElement(NewsActivity, {
      key: news.news.slug,
      data: news
    });
  }));
}